import { removeWhiteBackground } from './ARSCatalogUtils';

// Immagine placeholder per errori CORS e 404 (stessa di ARSCatalogUtils per coerenza)
const createPlaceholderImage = (width = 400, height = 400) => {
    return 'data:image/svg+xml;base64,' + btoa(`
<svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
  <rect width="${width}" height="${height}" fill="#f5f5f5" stroke="#d9d9d9" stroke-width="2"/>
  <g transform="translate(${width / 2}, ${height / 2})">
    <text x="0" y="-10" font-family="Arial, sans-serif" font-size="${Math.min(width, height) * 0.08}" fill="#999" text-anchor="middle">No Image</text>
    <text x="0" y="15" font-family="Arial, sans-serif" font-size="${Math.min(width, height) * 0.06}" fill="#999" text-anchor="middle">Available</text>
  </g>
</svg>
`);
};

const DEFAULT_PLACEHOLDER = createPlaceholderImage();

// Funzione wrapper per processare le immagini (ritornata a sincrona)
export const processImage = (imgUrl, id, processedImages, setProcessedImages) => {
    return removeWhiteBackground(imgUrl, id, processedImages, setProcessedImages);
}; 